// export const contentAPI = process.env.NODE_ENV === 'development' ? 'http://emeco.test/' : 'https://api.emeco.net/';
export const contentAPI = 'https://api.emeco.net/';

export const checkoutRoot = {
	57981829277: 'checkout.emeco.net',
	65580597415: 'checkout-eu.emeco.net',
};

export const checkoutAPI = (market) => {
	const version = '2026-07';
	if (!checkoutRoot[market]) return `https://checkout.emeco.net/api/${version}/graphql.json`;
	return `https://${checkoutRoot[market]}/api/${version}/graphql.json`;
};

const checkoutAccessToken = {
	account: '85c8da0e6895a85e7cf6e661c22871f3',
	57981829277: 'a1695888145b8fa12cfd371f65cec3dc',
	65580597415: 'c2c6aeb67c5037501da0a08fb26be154',
};

export const storefrontAccessToken = (market) => {
	if (!market || !checkoutAccessToken[market]) return 'a1695888145b8fa12cfd371f65cec3dc';
	return checkoutAccessToken[market];
};

export const useLanguageURLRoots = true;

// TEMPORARY (analytics test, Nov 2026): true hides the cookie banner and sends no consent signals at all
// (no gtag consent default, no Shopify visitorConsent), as before the banner existed. Set back to false to restore.
export const cookieConsentDisabled = false;

export const origin = 'https://www.emeco.net';

export const addressFieldOrder = [
	{ id: 'email', required: true },
	{ id: 'firstName', required: true },
	{ id: 'lastName', required: true },
	{ id: 'company', required: false },
	{ id: 'phone', required: true },
	{ id: 'address1', required: true },
	{ id: 'address2', required: false },
	{ id: 'zip', required: true },
	{ id: 'city', required: true },
	{ id: 'province', required: true },
	{ id: 'country', required: true },
	{ id: 'termsAndConditions', required: true },
];

export const urlRoots = [
	'emeco',
];

export const languageURLRoots = {
	en: ['emeco.coalesce.se', 'www.emeco.net'],
};

export const urlRootLanguage = {};

export const defaultCountry = {
	localhost: 'IT',
	'emeco.coalesce.se': 'IT',
	'www.emeco.net': 'IT',
};

export const restrictCountriesPerDomain = {};

export const baseCurrency = 'EUR';

export const shippingMethodsMapping = {};
